import React from 'react';

import type { IconProps } from '@squire/ui';
import { type AppColors, Icon } from '@squire/ui';

export const ChevronLeftIcon: React.FC<IconProps> = ({
  size = 16,
  color = 'iconPrimary',
  ...props
}) => {
  return (
    <Icon
      name="chevronLeft"
      color={(color as keyof AppColors) || 'iconPrimary'}
      size={size}
      {...props}
    />
  );
};
